module.exports = __webpack_public_path__ + "img/arrecredi_bdon_3.5a5dd3be.webp";